import DocumentationService from 'services/DocumentationService';

class DocumentationAdapter extends DocumentationService {

  createLink(link) {
    return {
      text: link.text,
      href: link.href
    };
  }

  loadLinks() {
    return this.getLinks()
       .then((result) => {
         return result.map(this.createLink);
       });
  }
}

const instance = new DocumentationAdapter();

export default instance;


// WEBPACK FOOTER //
// ./src/adapters/DocumentationAdapter.js